module.exports = __webpack_public_path__ + "static/media/181CO244.c594b75d.jpg";